module.exports = __webpack_public_path__ + "img/antes_despues_52.93433ba5.png";